const DATES = ['sun','mon', 'tue', 'wed', 'thu', 'fri', 'sat']
const DATES_FULL = ['Sunday','Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
const getSubTitle = (sub_title) => {
  var arr = sub_title.split(" ")
  var title_head = arr[0]
  return title_head;
}
const isDateToday = (date) => {
  let today = new Date()
  return date.getDate() == today.getDate() &&
      date.getMonth() == today.getMonth() &&
      date.getFullYear() == today.getFullYear()
}
const isDateWithinTwoDays = (date) => {
  let compareDate = new Date(new Date().getTime()+(3*24*60*60*1000));
  if(date <= compareDate){
  //if(date.getDate() <= compareDate.getDate() && date.getMonth() == compareDate.getMonth() && date.getFullYear() == compareDate.getFullYear()){
    return true;
  } else {
    return false;
  }
}
const isDateValid = (date) => {
  //let today = new Date();
  let compareDate = new Date(new Date().getTime()+(3*24*60*60*1000));
  if(date <= compareDate){
    return false;
  }
  return true;
}
const isDayDisabled = (date) => {
  var challenge = new Date(date);
  if(challenge.getDay() == 0){
    return true;
  }
  return false;
}
const isDateBeforeToday = (date) => {
  return new Date(date.toDateString()) < new Date(new Date().toDateString());
}
const getDateInfo = (d, active, disabled) => {
  var date = d.getDay(); // 0-6
  var day = d.getDate(); // 0-31
  // var month= d.getMonth(); // 0-11
  // var year=date.getFullYear(); // yyyy
  if(date == 0){
    //@TODO - Need to enhance this function to support disabling specific days
    disabled = true;
  }
  return {date: d, lbl_day: day, lbl_date: DATES[date], active, disabled }
}
const getNewDate = (obj_date, type, selected_date) => {
  var date = null, active = false, disabled = false;
  //console.log(obj_date);
  //obj_date.date = new Date(obj_date.date);
  let parseDate = new Date(obj_date.date);
  console.log(parseDate);
  if(type === 'prev'){
    date = new Date(parseDate.getTime() - (24 * 60 * 60 * 1000));
  }else{
    date = new Date(parseDate.getTime() + (24 * 60 * 60 * 1000));
  }
  console.log(date);
  if(isDateToday(date) || isDateBeforeToday(date) || isDateWithinTwoDays(date) || isDayDisabled(date)){
    disabled = true
  }
  if(!isDateValid(date)){
    disabled = true;
  }
  if(selected_date !== null && date.getTime() == selected_date.date.getTime()) {
    active = selected_date.active
    //disabled = selected_date.disabled
  }
  return getDateInfo(date, active, disabled)
}
const nth = function(d) {
  if (d > 3 && d < 21) return 'th';
  switch (d % 10) {
    case 1:  return "st";
    case 2:  return "nd";
    case 3:  return "rd";
    default: return "th";
  }
}
const getStrDate = (d) => {
  var date = d.getDay(); // 0-6
  var day = d.getDate(); // 1-31
  var month= d.getMonth(); // 0-11
  return DATES_FULL[date] + ', ' + MONTHS[month] + ' ' + day + nth(day)
}

const wait = (ms) => {
  return (x) => {
      return new Promise(resolve => setTimeout(() => resolve(x), ms));
  };
}

const validateAppointmentQuoteData = (storeData, type) => {
  let isValidAppointment = true
  let error = null

  /** store */
  if (!storeData.store) {
    isValidAppointment = false
    error = { message: 'Please select store location', redirect: 'store'}
    return { error, isValidAppointment }
  }

  /** service */
  if (!storeData.service) {
    isValidAppointment = false
    error = { message: 'Please select service', redirect: 'service'}
    return { error, isValidAppointment }
  } else {
    if (!storeData.service.service_alias || !storeData.service.sub_service || !Array.isArray(storeData.service.sub_service)) {
      isValidAppointment = false
      error = { message: 'Please select service', redirect: 'service'}
      return { error, isValidAppointment }
    } else {
      switch (storeData.service.service) {
        case 'automotive':
          if (!storeData.contact.year || !storeData.contact.make || !storeData.contact.model || !storeData.contact.door) {
              isValidAppointment = false
              error = { message: 'Please select year/marke/model/door', redirect: 'contact'}
              return { error, isValidAppointment }
          }
          break
        case 'residential':
          if (!storeData.contact.residential) {
            isValidAppointment = false
            error = { message: 'Please select residential type', redirect: 'contact'}
            return { error, isValidAppointment }
          }
          if (storeData.service.off_site) {
            if (!storeData.contact.address) {
              isValidAppointment = false
              error = { message: 'Please select offsite address', redirect: 'contact'}
              return { error, isValidAppointment }
            } else {
              if (!storeData.contact.address.street || !storeData.contact.address.city || !storeData.contact.address.state || !storeData.contact.address.zip) {
                isValidAppointment = false
                error = { message: 'Please select offsite address', redirect: 'contact'}
                return { error, isValidAppointment }
              }
            }
          }
          break
        case 'commercial':
          if (!storeData.contact.building) {
            isValidAppointment = false
            error = { message: 'Please select building type', redirect: 'contact'}
            return { error, isValidAppointment }
          }
          if (storeData.service.off_site) {
            if (!storeData.contact.address) {
              isValidAppointment = false
              error = { message: 'Please select offsite address', redirect: 'contact'}
              return { error, isValidAppointment }
            } else {
              if (!storeData.contact.address.street || !storeData.contact.address.city || !storeData.contact.address.state || !storeData.contact.address.zip) {
                isValidAppointment = false
                error = { message: 'Please select offsite address', redirect: 'contact'}
                return { error, isValidAppointment }
              }
            }
          }
          break
        case 'marine':
          if (!storeData.contact.vessel) {
            isValidAppointment = false
            error = { message: 'Please select vessel type', redirect: 'contact'}
            return { error, isValidAppointment }
          }
          if (storeData.service.off_site) {
            if (!storeData.contact.address) {
              isValidAppointment = false
              error = { message: 'Please select offsite address', redirect: 'contact'}
              return { error, isValidAppointment }
            } else {
              if (!storeData.contact.address.street || !storeData.contact.address.city || !storeData.contact.address.state || !storeData.contact.address.zip) {
                isValidAppointment = false
                error = { message: 'Please select offsite address', redirect: 'contact'}
                return { error, isValidAppointment }
              }
            }
          }
          break
        default:
          break
      }
    }
  }

  /** datetime */
  if (type === 'appointment') {
    if (!storeData.datetime) {
      isValidAppointment = false
      error = { message: 'Please select date and time', redirect: 'date'}
      return { error, isValidAppointment }
    } else {
      if (!storeData.datetime.time || !storeData.datetime.date) {
        isValidAppointment = false
        error = { message: 'Please select date and time', redirect: 'date'}
        return { error, isValidAppointment }
      }
    }
  }

  /** contact */
  if (!storeData.contact) {
    isValidAppointment = false
    error = { message: 'Please input contact information', redirect: 'contact'}
    return { error, isValidAppointment }
  } else {
    if (!storeData.contact.first_name || !storeData.contact.last_name || !storeData.contact.email || !storeData.contact.phone) {
      isValidAppointment = false
      error = { message: 'Please input contact information', redirect: 'contact'}
      return { error, isValidAppointment }
    }
  }

  return { error, isValidAppointment}
}

export { getSubTitle, getDateInfo, getNewDate, getStrDate, wait, validateAppointmentQuoteData, isDateToday, isDateWithinTwoDays, isDayDisabled }
